var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1222_31256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24782 12.9817C4.63328 13.3781 3.90097 13.5509 3.17402 13.471C2.44708 13.391 1.76983 13.0632 1.25617 12.5426L0.807105 12.1035C0.610232 11.9021 0.5 11.6317 0.5 11.3501C0.5 11.0685 0.610232 10.798 0.807105 10.5967L2.71312 8.71061C2.91281 8.51437 3.18158 8.40441 3.46156 8.40441C3.74153 8.40441 4.01031 8.51437 4.20999 8.71061C4.41136 8.90749 4.6818 9.01772 4.96342 9.01772C5.24504 9.01772 5.51547 8.90749 5.71684 8.71061L8.71058 5.71687C8.81045 5.61845 8.88976 5.50116 8.94389 5.37182C8.99802 5.24248 9.0259 5.10366 9.0259 4.96345C9.0259 4.82323 8.99802 4.68442 8.94389 4.55507C8.88976 4.42573 8.81045 4.30844 8.71058 4.21002C8.51434 4.01034 8.40438 3.74156 8.40438 3.46159C8.40438 3.18161 8.51434 2.91284 8.71058 2.71315L10.6066 0.817115C10.808 0.620241 11.0784 0.51001 11.36 0.51001C11.6417 0.51001 11.9121 0.620241 12.1135 0.817115L12.5526 1.26618C13.0731 1.77984 13.4009 2.45709 13.4809 3.18403C13.5609 3.91098 13.3881 4.64329 12.9916 5.25783C10.9259 8.3022 8.29751 10.9238 5.24782 12.9817Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1222_31256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.e95ae4eceb46154293688cafab8a5549.svg";
export { ForwardRef as ReactComponent };